import { render, staticRenderFns } from "./SKDataTableSearch.vue?vue&type=template&id=68f263bb&"
import script from "./SKDataTableSearch.vue?vue&type=script&lang=js&"
export * from "./SKDataTableSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports